import { getMessages } from '../../../../../../store/constants';

export const CARD_AGING_INDICATOR_BY_ACTIVITY = getMessages().getText('kanban.card.card_aging.activity');
export const CARD_AGING_INDICATOR_BY_LIST = getMessages().getText('kanban.card.card_aging.list');

export const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = ONE_HOUR * 24;
